import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './en.json'
import fr from './fr.json'
import de from './de.json'
import es from './es.json'
import it from './it.json'
import ja from './ja.json'
import id from './id.json'
import ko from './ko.json'
import nl from './nl.json'
import pl from './pl.json'
import pt from './pt.json'
import ru from './ru.json'
import tr from './tr.json'
import zh from './zh.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      de: { translation: de },
      es: { translation: es },
      it: { translation: it },
      ja: { translation: ja },
      id: { translation: id },
      ko: { translation: ko },
      nl: { translation: nl },
      pl: { translation: pl },
      pt: { translation: pt },
      ru: { translation: ru },
      tr: { translation: tr },
      zh: { translation: zh },
    },
    fallbackLng: 'en',
    detection: {
      order: ['path', 'navigator'],
      lookupFromPathIndex: 0,
      caches: [],
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
